/**
 * WarCarp player palette. Historical slot identities stay stable; names
 * fit the nine-color phone picker. Color-blind chips pair every slot with a
 * distinct pattern; a color alone is never an identity signal.
 */
import { PLAYER_COLOR_SLOTS, type PlayerColorSlot } from '@warcarp/api-types';

export type PlayerSlot = PlayerColorSlot;
export type PlayerPattern = 'solid' | 'diagonal' | 'dots' | 'crosshatch' |
  'horizontal' | 'vertical' | 'reverse-diagonal' | 'rings' | 'checker';

export const PLAYER_COLORS: Record<PlayerSlot, { hex: string; name: string; pattern: PlayerPattern }> = {
  1: { hex: '#C12C15', name: 'Cinder', pattern: 'solid' },
  2: { hex: '#2563EB', name: 'Admiral', pattern: 'diagonal' },
  3: { hex: '#8B7623', name: 'Harvest', pattern: 'dots' },
  4: { hex: '#166534', name: 'Briar', pattern: 'crosshatch' },
  5: { hex: '#272C35', name: 'Raven', pattern: 'horizontal' },
  6: { hex: '#6A0FD6', name: 'Dusk', pattern: 'vertical' },
  7: { hex: '#F59E0B', name: 'Forge', pattern: 'reverse-diagonal' },
  8: { hex: '#20C4B0', name: 'Tide', pattern: 'rings' },
  9: { hex: '#E04FA8', name: 'Bloom', pattern: 'checker' },
};
export const LOCKED_PLAYER_SLOTS: PlayerSlot[] = [...PLAYER_COLOR_SLOTS];

/** Keep malformed/legacy wire values inside the renderable palette. */
export function clampPlayerSlot(slot: number): PlayerSlot {
  const value = Number.isFinite(slot) ? Math.trunc(slot) : 1;
  return Math.min(Math.max(value, 1), PLAYER_COLOR_SLOTS.length) as PlayerSlot;
}
